function n(t) {
  try {
    return Function.toString.call(t).indexOf("[native code]") !== -1;
  } catch {
    return typeof t == "function";
  }
}
export {
  n as default
};
//# sourceMappingURL=isNativeFunction.mjs.map
